import { isSpanishLocale, getRegionFromCookie } from "../utility/locale-helper";
import {
  USCIS_URL,
  USCIS_URL_ES,
  MX_ACCEPTABLE_DOCUMENTS_URL_EN,
  MX_ACCEPTABLE_DOCUMENTS_URL_ES,
} from "../config/urls";

export interface MessageSet {
  readonly duringAppointment: string;
  readonly acceptableDocText: string;
  readonly acceptableDocLink: string;
}

const taskMessages: Map<string, MessageSet> = new Map();

taskMessages.set("us", {
  duringAppointment: "Checklist-MainPage-I9-DuringAppointment",
  acceptableDocText: "Checklist-MainPage-I9-Acceptable",
  acceptableDocLink: isSpanishLocale() ? USCIS_URL_ES : USCIS_URL,
});

taskMessages.set("mx", {
  duringAppointment: "Checklist-Mainpage-MX-DuringAppointment",
  acceptableDocText: "checklist-General-ClickHere",
  acceptableDocLink: isSpanishLocale() ? MX_ACCEPTABLE_DOCUMENTS_URL_ES : MX_ACCEPTABLE_DOCUMENTS_URL_EN,
});

taskMessages.set("gb", {
  duringAppointment: "Checklist-MainPage-I9-DuringAppointment",
  acceptableDocText: "Checklist-MainPage-I9-Acceptable",
  acceptableDocLink: isSpanishLocale() ? USCIS_URL_ES : USCIS_URL,
});

export function getMessageValues(): MessageSet {
  const messageValues = taskMessages.get(getRegionFromCookie().toLowerCase());
  if (!messageValues) {
    throw new Error(`Task messages not defined for region! ${getRegionFromCookie()}`);
  }

  return messageValues;
}
